module.exports = __webpack_public_path__ + "13362919965265bf35dfd42d942c2251.png";